module.exports = __webpack_public_path__ + "static/media/dicing.9bc3ca5d.mp3";